import { Injectable } from "@angular/core";
import { Notification } from "@shared/interfaces";
import { Subject } from "rxjs";
import { NotificationReceiverService } from "./NotificationReceiverService";
import { NotificationSenderService } from "./NotificationSenderService";

/**
 * @private Dont use this class
 *
 * @see NotificationSenderService to show notifications
 * @see NotificationReceiverService to receive notifications
 */

@Injectable()
export class NotificationService implements NotificationSenderService, NotificationReceiverService{
    public sendNotification$ = new Subject<Notification>;

    public notifyError(message: string, outsideAngular: boolean = false) {
        this.sendNotification$.next({
            type: 'error',
            message,
            outsideAngular
        });
    }

    public notifyInfo(message: string, outsideAngular: boolean = false) {
        this.sendNotification$.next({
            type: 'info',
            message,
            outsideAngular
        });
    }

    public notifySuccess(message: string, outsideAngular?: boolean) {
        this.sendNotification$.next({
            type: 'success',
            message,
            outsideAngular: outsideAngular ?? false
        });
    }
}
